export var FetchStatus;
(function (FetchStatus) {
    FetchStatus["FETCHING"] = "FETCHING";
    FetchStatus["FETCHING_MORE"] = "FETCHING_MORE";
    FetchStatus["REFETCHING"] = "REFETCHING";
    FetchStatus["ERROR"] = "ERROR";
    FetchStatus["FETCHED"] = "FETCHED";
    FetchStatus["UNINITIALIZED"] = "UNINITIALIZED";
    FetchStatus["NOT_FOUND"] = "NOT_FOUND";
})(FetchStatus || (FetchStatus = {}));
